// extracted by mini-css-extract-plugin
export default {"slider":"slider_slider__jCFIm","container":"slider_container__gkVBL","next":"slider_next__4nkIw","previous":"slider_previous__dzYo2"};